import { TUI_ICON_RESOLVER, TuiRoot } from '@taiga-ui/core';
import { Component, SkipSelf } from '@angular/core';
import { MainLayout } from './layout/main-layout/main-layout';
import { TuiStringHandler } from '@taiga-ui/cdk';

@Component({
  selector: 'app-root',
  imports: [TuiRoot, MainLayout],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  providers: [
    {
      provide: TUI_ICON_RESOLVER,
      deps: [[new SkipSelf(), TUI_ICON_RESOLVER]],
      useFactory(defaultResolver: TuiStringHandler<string>) {
        return (name: string) =>
          name.startsWith('@tui.') ? defaultResolver(name) : `/assets/icons/${name}.svg`;
      }
    }
  ]
})
export class App {}
